<!--  -->
<template>
  <div class="max-pharmacist-shell">
    <div class="w-view-shell" style="width: 20rem">
      <div class="pharmacist-course-shell">
        <div class="nav">
          <h2>专业科目选择课程</h2>
          <span>交费前，请先选择课程</span>
        </div>

        <div class="form">
          <div class="form-view">
            <el-form ref="form" inline>
              <el-form-item label="执业类型" style="margin-right: 20px">
                <el-input v-model="leixing" suffix-icon="el-icon-arrow-down" disabled></el-input>
              </el-form-item>
              <el-form-item label="选择年份">
                <el-select
                  v-model="year"
                  placeholder="请选择"
                  @change="onChange"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课程类型" style="width: 100%;" v-if="Number(year) == cuurrent_year">
                <div class="kc_type">
                  <div class="check" v-if="study_type == 1">整套课程</div>
                  <div class="check" v-if="study_type == 2">零散课程</div>
                </div>
              </el-form-item>
            </el-form>
            <span v-if="Number(year) <= 2019">选课说明：关于专业科目学习要求根据人社部《专业技术人员继续教育规定》，所选课程不少于45学时，国家一类15学分。</span>
            <span v-else-if="Number(year) > 2019 && Number(year) < cuurrent_year">选课说明：关于专业科目学习要求根据人社部《专业技术人员继续教育规定》，所选课程不少于60学时，每学时的时长为40分钟，共计2400分钟，国家一类20学分。</span>
            <span v-else>
              <!-- 选课说明：关于专业科目学习要求根据人社部《专业技术人员继续教育规定》，所选课程<span>不少于60学时</span>，每学时的时长为40分钟，自由选择课程，<span>累计达到2400分钟</span>即可，<span>计20学分</span>。 -->
              <template v-if="study_type == 1">
                选课说明：根据《执业药师继续教育暂行规定》，要求专业科目<span>不少于60学时，计20学分。选课达到60学时</span>方可付费。
              </template>
              <template v-else-if="study_type == 2">
                选课说明：根据《执业药师继续教育暂行规定》，要求专业科目<span>不少于60学时，计20学分</span>
              </template>
            </span>
          </div>
          <div class="card">
            <img src="@/assets/wechat.png" alt="" />
            <div>
              按省药监局统一要求，学习中有人脸识别，如电脑无摄像设备，<span style="color: red">请扫码关注公众号</span>进行学习考试。
            </div>
          </div>
        </div>

        <whole-view ref="whole" :leixing="leixing" v-if="study_type == 1"></whole-view>
        <loose-view ref="loose" :leixing="leixing" :need="need" :total_period="total_period" v-if="study_type == 2"></loose-view>
      </div>
    </div>
  </div>
</template>

<script>
import WholeView from './components/whole.vue'
import LooseView from './components/loose.vue'

export default {
  components: {
    WholeView,
    LooseView
  },
  data() {
    return {
      leixing: '', // 身份类型
      info: {}, // 教师身份数据
      options: [], // 年份选择列表
      year: "", // 当前已选年份，
      cuurrent_year: '',  // 新学年份
      total_period: 0, // 已获取学时
      need: 60, // 所需学时
      study_type: 1,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.cuurrent_year = new Date().getFullYear()
    this.getUserInfo()
  },
  mounted() {
    
  },
  //方法集合
  methods: {
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        if (res.code == 10010) {
          let user_info = res.data.user_info
          this.leixing = user_info.leixing
          this.$store.state.user_info = user_info;
          this.$store.state.user_img = user_info.head_img_url;
          localStorage.setItem("user_id", user_info.user_id);
          localStorage.setItem("user_info", JSON.stringify(user_info));
          this.getTeacher()
        }
      });
    },
    getTeacher() {
      this.API.post("user/phar_in-get_phar_info", {}).then((res) => {
        this.info = res.data;
        this.options = this.info.phar_info.map((item) => {
          return {
            label: item.bx_year,
            value: item.bx_year,
          };
        });
        this.year = this.info.phar_year
        this.info.phar_info.forEach((item) => {
          if (item.bx_year == this.info.phar_year) {
            this.need = item.need
            this.study_type = item.study_type
            this.getBuyStatus(item.info_id);
          }
          if (item.is_buxue == 0) {
            this.cuurrent_year = item.bx_year
          }
        });
      });
    },
    onChange() {
      this.info.phar_info.forEach((item) => {
        if (item.bx_year == this.year) {
          this.getBuyStatus(item.info_id);
        }
      });
    },
    getBuyStatus(id) {
      this.API.post("login/user_acc-phar_choose", { phar_id: id }).then(
        (res) => {
          localStorage.setItem("token", res.data.token);
          this.API.post("user/phar_in-buy_status", {}).then((result) => {
            this.total_period = this.$route.query.total_period || ''
            if (result.data.course_status && this.total_period == '') {
              this.$router.push({
                path: '/personal',
                query: {code: 10}
              })
            } else {
              this.$nextTick(() => {
                if (this.study_type == 2) {
                  this.$refs.loose.get_course_list(this.year, this.cuurrent_year)
                } else {
                  this.$refs.whole.get_course_list(this.year, this.cuurrent_year)
                } 
              })
            }
          });
        }
      );
    },
  },
}
</script>

<style lang='less' scoped>
.max-pharmacist-shell {
  width: 100%;
  background-color: #fff;
  padding-top: 20px;
  .pharmacist-course-shell {
    width: 100%;
    min-height: 70vh;
    background-color: #fff;
    padding-bottom: 20px;
    .nav {
      display: flex;
      align-items: flex-end;
      margin-top: 30px;
      h2 {
        font-size: 24px;
      }
      span {
        margin-left: 10px;
        color: #2aa9b5;
        font-size: 20px;
      }
    }
    .form {
      margin: 30px 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e3e3e3;
      padding-bottom: 20px;
      .form-view {
        width: 80%;
        /deep/ .el-form-item {
          display: inline-flex;
          align-items: center;
        }
        /deep/ .el-input__suffix {
          height: fit-content;
        }
        /deep/ .el-form-item__label {
          font-weight: bold;
          color: #000000;
          font-size: 24px;
        }
        /deep/ .el-input__inner {
          font-size: 24px;
          font-weight: bold;
          width: 300px;
          height: auto;
          line-height: inherit;
        }
        /deep/ .el-radio-button__inner {
          font-size: 20px;
          &:hover {
            color: #2aa9b5;
          }
        }
        /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
          background-color: #2aa9b5;
          border-color: #2aa9b5;
          &:hover {
            color: #fff;
          }
        }
        .kc_type {
          display: flex;
          align-items: center;
          border: 1px solid #f0f0f0;
          background-color: #fff;
          border-radius: 3px;
          overflow: hidden;
          > div {
            width: 120px;
            height: 45px;
            color: #000;
            line-height: 45px;
            text-align: center;
            cursor: pointer;
            font-size: 20px;
          }
          .check {
            color: #fff;
            background-color: #2aa9b5;
          }
        }
        > span {
          display: block;
          margin-top: 20px;
          font-size: 20px;
          > span {
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
      .card {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 120px;
        }
        div {
          font-size: 17px;
          margin-left: 10px;
          width: 170px;
        }
      }
    }
  }
}
</style>